/* eslint-disable no-console */
import axios, {AxiosError} from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useUserStore from '../../../store/userStore/userStore';

interface ErrorResponse {
  message: string;
}
const deleteUser = async (userId: string): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const res = await axios.request({
      method: CRUDMethods.DELETE,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.user}/UM/${userId}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return res.data;
  } catch (err) {
    const axiosError = err as AxiosError;
    if (axiosError.response) {
      const responseData = axiosError.response.data as ErrorResponse;

      return {
        status: 'error',
        message: responseData.message || 'An error occurred'
      };
    }

    return {
      status: 'error',
      message: axiosError.message || 'An error occurred'
    };
  }
};
export default deleteUser;
